import { Col, Container, Row } from "react-bootstrap";
import clsx from "clsx";
import ProfileInfoComponent from "./components/ProfileInfoComponent";
import ChangePasswordComponent from "./components/ChangePasswordComponent";
import EmailNotificationSettings from "./components/EmailNotificationSettings";
import { getUserProfileNotificationSettings } from "../../selectors/user";
import * as userSelectors from "../../selectors/user";

function Profile({ profileData }) {
  //TODO PROFILE PAGE
  const notificationSettings = userSelectors.getUserProfileNotificationSettings(profileData);
  return (
    <div className="container-fluid">
      <Row>
        <Col lg={4} sm={12}>
          <ProfileInfoComponent profileData={profileData} />
        </Col>
        <Col lg={8} sm={12}>
          <ChangePasswordComponent />
          <EmailNotificationSettings data={notificationSettings} />

        </Col>
      </Row>
    </div>
  );
}

export default Profile;
